import React from 'react';

import { IconWrapper } from '../styled-components';
import { ReactComponent as document } from './document-text.svg';
import styled from "styled-components";
const DocumentIcon = styled(document)`
  
`

type DocumentLogoProps = {
  scale?: number;
  altText: string;
  viewType: string;
};

const Document: React.FC<DocumentLogoProps> = ({ scale = 1, altText, viewType }) => {
  return (
    <IconWrapper width={2 * scale} height={2 * scale} aria-label={altText} style={{"width": "1rem", marginTop: viewType === "row"? '5px' : '2px'}}>
      <DocumentIcon/>
    </IconWrapper>
  );
};

export default Document;